<template>
  <v-tabs>
    <v-tab>１個目のたぶ</v-tab>
    <v-tab-item>
       <div class="text-xs-center">

         <v-flex class="ma-5">
         <v-btn outline color="pink" dark @click="dialogIsActive=true">表示する</v-btn>
         </v-flex>

         <v-dialog v-model="dialogIsActive" width="500">

          <v-card>
           <v-card-title class="headline grey lighten-2" primary-title>タイトルを入れるとこ</v-card-title>
            <v-card-text>
              <p>ダイアログのテスト</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialogIsActive=false">閉じる</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-tab-item>

    <v-tab>2個目のたぶ</v-tab>
    <v-tab-item>
       <div class="text-xs-center">

         <v-flex class="ma-5">
         <v-btn outline color="pink" dark @click="dialog2IsActive=true">表示する2</v-btn>
         </v-flex>

         <v-dialog v-model="dialog2IsActive" width="500">

          <v-card>
           <v-card-title class="headline grey lighten-2" primary-title>タイトルを入れるとこ2</v-card-title>
            <v-card-text>
              <p>本文入れるところ2</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialog2IsActive=false">閉じる2</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-tab-item>

    <v-tab>3個目のたぶ</v-tab>
    <v-tab-item>
       <div class="text-xs-center">

         <v-flex class="ma-5">
         <v-btn outline color="pink" dark @click="dialog3IsActive=true">表示する3</v-btn>
         </v-flex>

         <v-dialog v-model="dialog3IsActive" width="500">

          <v-card>
           <v-card-title class="headline grey lighten-2" primary-title>タイトルを入れるとこ3</v-card-title>
            <v-card-text>
              <p>本文入れるところ3</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialog3IsActive=false">閉じる3</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-tab-item>

  </v-tabs>
</template>

<script>

export default {
    data() {
      return {
        dialogIsActive: false,
        dialog2IsActive: false,
        dialog3IsActive: false
      }
    }
}
</script>
